(() => {
  const storageKey = 'verdosa-home-product-view';
  const mobile = window.matchMedia('(max-width: 749px), (min-width: 750px) and (max-width: 1199px) and (orientation: landscape) and (pointer: coarse), (min-width: 750px) and (pointer: fine)');

  const readPreference = () => {
    try {
      return localStorage.getItem(storageKey) === 'compact' ? 'compact' : 'standard';
    } catch (_) {
      return 'standard';
    }
  };

  const savePreference = (value) => {
    try {
      localStorage.setItem(storageKey, value);
    } catch (_) {}
  };

  const icon = (type) => type === 'compact'
    ? '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>'
    : '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="3" width="16" height="18"/><path d="M4 8h16"/></svg>';

  const initialise = (scope = document) => {
    const section = scope.querySelector?.('main[data-template="index"] .section-resource-list')
      || document.querySelector('main[data-template="index"] .section-resource-list');
    if (!section || section.querySelector('.verdosa-mobile-view-toggle')) return;

    const grid = section.querySelector('.resource-list--grid');
    if (!grid) return;

    const control = document.createElement('div');
    control.className = 'verdosa-mobile-view-toggle';
    control.innerHTML = `
      <div class="verdosa-mobile-view-toggle__group" role="group" aria-label="Product card view">
        <button type="button" data-home-view="standard" aria-pressed="false">${icon('standard')}<span>Standard</span></button>
        <button type="button" data-home-view="compact" aria-pressed="false">${icon('compact')}<span>Compact</span></button>
      </div>`;

    section.insertBefore(control, grid);
    const buttons = [...control.querySelectorAll('button')];

    const apply = (value, persist = false) => {
      const view = value === 'compact' ? 'compact' : 'standard';
      if (mobile.matches) section.dataset.homeProductView = view;
      else delete section.dataset.homeProductView;
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button.dataset.homeView === view)));
      if (persist) savePreference(view);
    };

    buttons.forEach((button) => button.addEventListener('click', () => apply(button.dataset.homeView, true)));
    apply(readPreference());
    mobile.addEventListener?.('change', () => apply(readPreference()));
  };

  const start = () => initialise(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();
